export enum ETheme {
  LIGHT = 'padrao',
  DARK = 'padrao-dark',
}

export const themeOptions = {
  themeName: localStorage.getItem('theme'),
};

export function getCurrentTheme() {
  return themeOptions.themeName;
}

export function isThemeActive(themeName: string) {
  return (themeOptions.themeName || ETheme.LIGHT) == themeName;
}

export function changeTheme(themeName?: string) {
  if (themeName == undefined) {
    themeName = localStorage.getItem('theme') || ETheme.LIGHT;
  }
  if (themeName !== ETheme.LIGHT && themeName !== ETheme.DARK) {
    themeName = ETheme.LIGHT;
  }
  themeOptions.themeName = themeName;
  localStorage.setItem('theme', themeName);
  document.body.classList.toggle('theme-dark', themeName === ETheme.DARK);

  const dark = themeName === ETheme.DARK;
  replaceLink(document.getElementById('theme-css') as HTMLLinkElement, 'assets/theme/theme-' + themeName + '.css', dark);
  replaceLink(document.getElementById('layout-css') as HTMLLinkElement, 'assets/layout/css/layout-' + themeName + '.css', dark);
}

function replaceLink(linkElement: HTMLLinkElement, href: string, depoisDosEstilos: boolean) {
  if (!linkElement || linkElement.getAttribute('href') === href) {
    return;
  }
  const id = linkElement.getAttribute('id');
  const cloneLinkElement = linkElement.cloneNode(true) as HTMLLinkElement;

  cloneLinkElement.setAttribute('href', href);
  cloneLinkElement.setAttribute('id', id + '-clone');

  if (depoisDosEstilos) {
    document.head.appendChild(cloneLinkElement);
  } else {
    linkElement.parentNode.insertBefore(cloneLinkElement, linkElement.nextSibling);
  }

  cloneLinkElement.addEventListener('load', () => {
    linkElement.remove();
    cloneLinkElement.setAttribute('id', id);
  });
}
